import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../../../../services/endpoints/endpoints.service";

export const useConditionsOptions = () => {
	const queryClient = useQueryClient();
	const queryKey = ["participant-conditions-options"];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getConditionsOptions();
			return response;
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
